/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.7.1.0 (NJsonSchema v9.6.0.0) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class FileuploadApiService {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.fileUpload;
    }

    uploadFiletype(file: UserFileType): Observable<UserFileType> {
      let url_ = this.baseUrl + "/api/UserFileupload/UploadFiletype";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(file);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUploadFiletype(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUploadFiletype(response_);
              } catch (e) {
                  return <Observable<UserFileType>><any>Observable.throw(e);
              }
          } else
              return <Observable<UserFileType>><any>Observable.throw(response_);
      });
  }

  protected processUploadFiletype(response: Response): Observable<UserFileType> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? UserFileType.fromJS(resultData200) : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 404) {
          const _responseText = response.text();
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 ? CustomError.fromJS(resultData404) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result404);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UserFileType>(<any>null);
  }

  uploadFiles(accountId: string, fileTypeId: string, file: UserFiles): Observable<UserFiles> {
      let url_ = this.baseUrl + "/api/UserFileupload/UploadFiles/{accountId}/{fileTypeId}";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined.");
      url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
      if (fileTypeId === undefined || fileTypeId === null)
          throw new Error("The parameter 'fileTypeId' must be defined.");
      url_ = url_.replace("{fileTypeId}", encodeURIComponent("" + fileTypeId));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(file);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUploadFiles(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUploadFiles(response_);
              } catch (e) {
                  return <Observable<UserFiles>><any>Observable.throw(e);
              }
          } else
              return <Observable<UserFiles>><any>Observable.throw(response_);
      });
  }

  protected processUploadFiles(response: Response): Observable<UserFiles> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? UserFiles.fromJS(resultData200) : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 404) {
          const _responseText = response.text();
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 ? CustomError.fromJS(resultData404) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result404);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UserFiles>(<any>null);
  }

  getFiles(accountId: string, deviceModel: string): Observable<UserFileType[]> {
      let url_ = this.baseUrl + "/api/UserFileupload/GetFiles/{accountId}?";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined.");
      url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
      if (deviceModel !== undefined)
          url_ += "deviceModel=" + encodeURIComponent("" + deviceModel) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetFiles(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetFiles(response_);
              } catch (e) {
                  return <Observable<UserFileType[]>><any>Observable.throw(e);
              }
          } else
              return <Observable<UserFileType[]>><any>Observable.throw(response_);
      });
  }

  protected processGetFiles(response: Response): Observable<UserFileType[]> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
              result200 = [];
              for (let item of resultData200)
                  result200.push(UserFileType.fromJS(item));
          }
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UserFileType[]>(<any>null);
  }

  getFilesByFileType(accountId: string, fileTypeId: string): Observable<UserFiles[]> {
      let url_ = this.baseUrl + "/api/UserFileupload/GetFilesByFileType/{accountId}/{fileTypeId}";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined.");
      url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
      if (fileTypeId === undefined || fileTypeId === null)
          throw new Error("The parameter 'fileTypeId' must be defined.");
      url_ = url_.replace("{fileTypeId}", encodeURIComponent("" + fileTypeId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetFilesByFileType(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetFilesByFileType(response_);
              } catch (e) {
                  return <Observable<UserFiles[]>><any>Observable.throw(e);
              }
          } else
              return <Observable<UserFiles[]>><any>Observable.throw(response_);
      });
  }

  protected processGetFilesByFileType(response: Response): Observable<UserFiles[]> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
              result200 = [];
              for (let item of resultData200)
                  result200.push(UserFiles.fromJS(item));
          }
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UserFiles[]>(<any>null);
  }

  updateFiles(accountId: string, fileTypeId: string, file: UserFiles): Observable<UserFiles> {
      let url_ = this.baseUrl + "/api/UserFileupload/UpdateFiles/{accountId}/{fileTypeId}";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined.");
      url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
      if (fileTypeId === undefined || fileTypeId === null)
          throw new Error("The parameter 'fileTypeId' must be defined.");
      url_ = url_.replace("{fileTypeId}", encodeURIComponent("" + fileTypeId));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(file);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUpdateFiles(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUpdateFiles(response_);
              } catch (e) {
                  return <Observable<UserFiles>><any>Observable.throw(e);
              }
          } else
              return <Observable<UserFiles>><any>Observable.throw(response_);
      });
  }

  protected processUpdateFiles(response: Response): Observable<UserFiles> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? UserFiles.fromJS(resultData200) : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UserFiles>(<any>null);
  }

  updateFileType(userFile: UserFileType): Observable<UserFileType> {
      let url_ = this.baseUrl + "/api/UserFileupload/UpdateFileType";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(userFile);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUpdateFileType(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUpdateFileType(response_);
              } catch (e) {
                  return <Observable<UserFileType>><any>Observable.throw(e);
              }
          } else
              return <Observable<UserFileType>><any>Observable.throw(response_);
      });
  }

  protected processUpdateFileType(response: Response): Observable<UserFileType> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? UserFileType.fromJS(resultData200) : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UserFileType>(<any>null);
  }

  deleteFileType(accountId: string, fileTypeId: string): Observable<boolean> {
      let url_ = this.baseUrl + "/api/UserFileupload/DeleteFileType/{accountId}/{fileTypeId}";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined.");
      url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
      if (fileTypeId === undefined || fileTypeId === null)
          throw new Error("The parameter 'fileTypeId' must be defined.");
      url_ = url_.replace("{fileTypeId}", encodeURIComponent("" + fileTypeId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "delete",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processDeleteFileType(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processDeleteFileType(response_);
              } catch (e) {
                  return <Observable<boolean>><any>Observable.throw(e);
              }
          } else
              return <Observable<boolean>><any>Observable.throw(response_);
      });
  }

  protected processDeleteFileType(response: Response): Observable<boolean> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<boolean>(<any>null);
  }

  deleteFile(accountId: string, fileTypeId: string, fileId: string): Observable<boolean> {
      let url_ = this.baseUrl + "/api/UserFileupload/DeleteFile/{accountId}/{fileTypeId}/{fileId}";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined.");
      url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
      if (fileTypeId === undefined || fileTypeId === null)
          throw new Error("The parameter 'fileTypeId' must be defined.");
      url_ = url_.replace("{fileTypeId}", encodeURIComponent("" + fileTypeId));
      if (fileId === undefined || fileId === null)
          throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "delete",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processDeleteFile(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processDeleteFile(response_);
              } catch (e) {
                  return <Observable<boolean>><any>Observable.throw(e);
              }
          } else
              return <Observable<boolean>><any>Observable.throw(response_);
      });
  }

  protected processDeleteFile(response: Response): Observable<boolean> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<boolean>(<any>null);
  }

  uploadFileContent(currentBlockId: number, totalBlocks: number, accountId: string, fileType: string, fileTypeId: string, fileId: string, fileName: string, fileVersion: number): Observable<UploadContentResponse> {
      let url_ = this.baseUrl + "/api/UserFileupload/UploadFileContent?";
      if (currentBlockId === undefined || currentBlockId === null)
          throw new Error("The parameter 'currentBlockId' must be defined and cannot be null.");
      else
          url_ += "currentBlockId=" + encodeURIComponent("" + currentBlockId) + "&";
      if (totalBlocks === undefined || totalBlocks === null)
          throw new Error("The parameter 'totalBlocks' must be defined and cannot be null.");
      else
          url_ += "totalBlocks=" + encodeURIComponent("" + totalBlocks) + "&";
      if (accountId === undefined || accountId === null)
          throw new Error("The parameter 'accountId' must be defined and cannot be null.");
      else
          url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
      if (fileType === undefined)
          throw new Error("The parameter 'fileType' must be defined.");
      else
          url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
      if (fileTypeId === undefined || fileTypeId === null)
          throw new Error("The parameter 'fileTypeId' must be defined and cannot be null.");
      else
          url_ += "fileTypeId=" + encodeURIComponent("" + fileTypeId) + "&";
      if (fileId === undefined || fileId === null)
          throw new Error("The parameter 'fileId' must be defined and cannot be null.");
      else
          url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
      if (fileName === undefined)
          throw new Error("The parameter 'fileName' must be defined.");
      else
          url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
      if (fileVersion === undefined || fileVersion === null)
          throw new Error("The parameter 'fileVersion' must be defined and cannot be null.");
      else
          url_ += "fileVersion=" + encodeURIComponent("" + fileVersion) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUploadFileContent(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUploadFileContent(response_);
              } catch (e) {
                  return <Observable<UploadContentResponse>><any>Observable.throw(e);
              }
          } else
              return <Observable<UploadContentResponse>><any>Observable.throw(response_);
      });
  }

  protected processUploadFileContent(response: Response): Observable<UploadContentResponse> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? UploadContentResponse.fromJS(resultData200) : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? UploadContentResponse.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<UploadContentResponse>(<any>null);
  }

  getAll(): Observable<string[]> {
      let url_ = this.baseUrl + "/api/v1/Values";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetAll(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetAll(response_);
              } catch (e) {
                  return <Observable<string[]>><any>Observable.throw(e);
              }
          } else
              return <Observable<string[]>><any>Observable.throw(response_);
      });
  }

  protected processGetAll(response: Response): Observable<string[]> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
              result200 = [];
              for (let item of resultData200)
                  result200.push(item);
          }
          return Observable.of(result200);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<string[]>(<any>null);
  }

  create(value: string): Observable<void> {
      let url_ = this.baseUrl + "/api/v1/Values";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(value);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processCreate(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processCreate(response_);
              } catch (e) {
                  return <Observable<void>><any>Observable.throw(e);
              }
          } else
              return <Observable<void>><any>Observable.throw(response_);
      });
  }

  protected processCreate(response: Response): Observable<void> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 201) {
          const _responseText = response.text();
          return Observable.of<void>(<any>null);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<void>(<any>null);
  }

  getById(id: number): Observable<void> {
      let url_ = this.baseUrl + "/api/v1/Values/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetById(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetById(response_);
              } catch (e) {
                  return <Observable<void>><any>Observable.throw(e);
              }
          } else
              return <Observable<void>><any>Observable.throw(response_);
      });
  }

  protected processGetById(response: Response): Observable<void> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          return Observable.of<void>(<any>null);
      } else if (status === 404) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<void>(<any>null);
  }

  update(id: number, value: string): Observable<void> {
      let url_ = this.baseUrl + "/api/v1/Values/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(value);

      let options_ = {
          body: content_,
          method: "put",
          headers: new Headers({
              "Content-Type": "application/json",
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUpdate(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUpdate(response_);
              } catch (e) {
                  return <Observable<void>><any>Observable.throw(e);
              }
          } else
              return <Observable<void>><any>Observable.throw(response_);
      });
  }

  protected processUpdate(response: Response): Observable<void> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          return Observable.of<void>(<any>null);
      } else if (status === 404) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<void>(<any>null);
  }

  delete(id: number): Observable<void> {
      let url_ = this.baseUrl + "/api/v1/Values/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "delete",
          headers: new Headers({
              "Content-Type": "application/json",
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processDelete(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processDelete(response_);
              } catch (e) {
                  return <Observable<void>><any>Observable.throw(e);
              }
          } else
              return <Observable<void>><any>Observable.throw(response_);
      });
  }

  protected processDelete(response: Response): Observable<void> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          return Observable.of<void>(<any>null);
      } else if (status === 404) {
          const _responseText = response.text();
          return throwException("A server error occurred.", status, _responseText, _headers);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<void>(<any>null);
  }
}

export class UserFileType implements IUserFileType {
  id: string;
  name?: string;
  version: number;
  type?: string;
  accountId: string;
  notes?: string;
  files?: UserFiles[];
  status?: string;
  createdDate: Date;
  lastModifedDate: Date;
  lastModifedBy?: string;
  totalFiles: number;

  constructor(data?: IUserFileType) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.id = data["id"] !== undefined ? data["id"] : <any>null;
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
          this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
          this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
          this.notes = data["Notes"] !== undefined ? data["Notes"] : <any>null;
          if (data["Files"] && data["Files"].constructor === Array) {
              this.files = [];
              for (let item of data["Files"])
                  this.files.push(UserFiles.fromJS(item));
          }
          this.status = data["Status"] !== undefined ? data["Status"] : <any>null;
          this.createdDate = data["CreatedDate"] ? new Date(data["CreatedDate"].toString()) : <any>null;
          this.lastModifedDate = data["LastModifedDate"] ? new Date(data["LastModifedDate"].toString()) : <any>null;
          this.lastModifedBy = data["LastModifedBy"] !== undefined ? data["LastModifedBy"] : <any>null;
          this.totalFiles = data["TotalFiles"] !== undefined ? data["TotalFiles"] : <any>null;
      }
  }

  static fromJS(data: any): UserFileType {
      let result = new UserFileType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Version"] = this.version !== undefined ? this.version : <any>null;
      data["Type"] = this.type !== undefined ? this.type : <any>null;
      data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
      data["Notes"] = this.notes !== undefined ? this.notes : <any>null;
      if (this.files && this.files.constructor === Array) {
          data["Files"] = [];
          for (let item of this.files)
              data["Files"].push(item.toJSON());
      }
      data["Status"] = this.status !== undefined ? this.status : <any>null;
      data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
      data["LastModifedDate"] = this.lastModifedDate ? this.lastModifedDate.toISOString() : <any>null;
      data["LastModifedBy"] = this.lastModifedBy !== undefined ? this.lastModifedBy : <any>null;
      data["TotalFiles"] = this.totalFiles !== undefined ? this.totalFiles : <any>null;
      return data;
  }
}

export interface IUserFileType {
  id: string;
  name?: string;
  version: number;
  type?: string;
  accountId: string;
  notes?: string;
  files?: UserFiles[];
  status?: string;
  createdDate: Date;
  lastModifedDate: Date;
  lastModifedBy?: string;
  totalFiles: number;
}

export class UserFiles implements IUserFiles {
  fileId: string;
  fileName?: string;
  version: number;
  status?: string;
  uploadStatus?: string;
  fileSize?: number;
  blobUrl?: string;
  versionFile?: string;
  createdDate: Date;

  constructor(data?: IUserFiles) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.fileId = data["FileId"] !== undefined ? data["FileId"] : <any>null;
          this.fileName = data["FileName"] !== undefined ? data["FileName"] : <any>null;
          this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
          this.status = data["Status"] !== undefined ? data["Status"] : <any>null;
          this.uploadStatus = data["UploadStatus"] !== undefined ? data["UploadStatus"] : <any>null;
          this.fileSize = data["FileSize"] !== undefined ? data["FileSize"] : <any>null;
          this.blobUrl = data["blobUrl"] !== undefined ? data["blobUrl"] : <any>null;
          this.versionFile = data["VersionFile"] !== undefined ? data["VersionFile"] : <any>null;
          this.createdDate = data["CreatedDate"] ? new Date(data["CreatedDate"].toString()) : <any>null;
      }
  }

  static fromJS(data: any): UserFiles {
      let result = new UserFiles();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["FileId"] = this.fileId !== undefined ? this.fileId : <any>null;
      data["FileName"] = this.fileName !== undefined ? this.fileName : <any>null;
      data["Version"] = this.version !== undefined ? this.version : <any>null;
      data["Status"] = this.status !== undefined ? this.status : <any>null;
      data["UploadStatus"] = this.uploadStatus !== undefined ? this.uploadStatus : <any>null;
      data["FileSize"] = this.fileSize !== undefined ? this.fileSize : <any>null;
      data["blobUrl"] = this.blobUrl !== undefined ? this.blobUrl : <any>null;
      data["VersionFile"] = this.versionFile !== undefined ? this.versionFile : <any>null;
      data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
      return data;
  }
}

export interface IUserFiles {
  fileId: string;
  fileName?: string;
  version: number;
  status?: string;
  uploadStatus?: string;
  fileSize?: number;
  blobUrl?: string;
  versionFile?: string;
  createdDate: Date;
}

export class CustomError implements ICustomError {
  severity: SeverityEnum;
  statusCode: HttpStatusCode;
  userCode?: string;
  errorMessage?: string;
  memberName?: string;
  sourceFilePath?: string;
  sourceLineNumber: number;
  exceptionType?: string;
  stackTrace?: string[];
  asString?: string;

  constructor(data?: ICustomError) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
          this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
          this.userCode = data["UserCode"] !== undefined ? data["UserCode"] : <any>null;
          this.errorMessage = data["ErrorMessage"] !== undefined ? data["ErrorMessage"] : <any>null;
          this.memberName = data["MemberName"] !== undefined ? data["MemberName"] : <any>null;
          this.sourceFilePath = data["SourceFilePath"] !== undefined ? data["SourceFilePath"] : <any>null;
          this.sourceLineNumber = data["SourceLineNumber"] !== undefined ? data["SourceLineNumber"] : <any>null;
          this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
          if (data["StackTrace"] && data["StackTrace"].constructor === Array) {
              this.stackTrace = [];
              for (let item of data["StackTrace"])
                  this.stackTrace.push(item);
          }
          this.asString = data["AsString"] !== undefined ? data["AsString"] : <any>null;
      }
  }

  static fromJS(data: any): CustomError {
      let result = new CustomError();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
      data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
      data["UserCode"] = this.userCode !== undefined ? this.userCode : <any>null;
      data["ErrorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
      data["MemberName"] = this.memberName !== undefined ? this.memberName : <any>null;
      data["SourceFilePath"] = this.sourceFilePath !== undefined ? this.sourceFilePath : <any>null;
      data["SourceLineNumber"] = this.sourceLineNumber !== undefined ? this.sourceLineNumber : <any>null;
      data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
      if (this.stackTrace && this.stackTrace.constructor === Array) {
          data["StackTrace"] = [];
          for (let item of this.stackTrace)
              data["StackTrace"].push(item);
      }
      data["AsString"] = this.asString !== undefined ? this.asString : <any>null;
      return data;
  }
}

export interface ICustomError {
  severity: SeverityEnum;
  statusCode: HttpStatusCode;
  userCode?: string;
  errorMessage?: string;
  memberName?: string;
  sourceFilePath?: string;
  sourceLineNumber: number;
  exceptionType?: string;
  stackTrace?: string[];
  asString?: string;
}

export enum SeverityEnum {
  None = 0,
  Warning = 1,
  Error = 2,
  Exception = 3,
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultipleChoices = 300,
  Ambiguous = 300,
  MovedPermanently = 301,
  Moved = 301,
  Found = 302,
  Redirect = 302,
  SeeOther = 303,
  RedirectMethod = 303,
  NotModified = 304,
  UseProxy = 305,
  Unused = 306,
  TemporaryRedirect = 307,
  RedirectKeepVerb = 307,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  RequestEntityTooLarge = 413,
  RequestUriTooLong = 414,
  UnsupportedMediaType = 415,
  RequestedRangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  UpgradeRequired = 426,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
}

export class UploadContentResponse implements IUploadContentResponse {
  isLastBlock: boolean;
  error: boolean;
  message?: string;

  constructor(data?: IUploadContentResponse) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isLastBlock = data["isLastBlock"] !== undefined ? data["isLastBlock"] : <any>null;
          this.error = data["error"] !== undefined ? data["error"] : <any>null;
          this.message = data["message"] !== undefined ? data["message"] : <any>null;
      }
  }

  static fromJS(data: any): UploadContentResponse {
      let result = new UploadContentResponse();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["isLastBlock"] = this.isLastBlock !== undefined ? this.isLastBlock : <any>null;
      data["error"] = this.error !== undefined ? this.error : <any>null;
      data["message"] = this.message !== undefined ? this.message : <any>null;
      return data;
  }
}

export interface IUploadContentResponse {
  isLastBlock: boolean;
  error: boolean;
  message?: string;
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
  super();

      this.message = message;
      this.status = status;
      this.response = response;
  this.headers = headers;
      this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
      return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if(result !== null && result !== undefined)
      return Observable.throw(result);
  else
      return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
      let reader = new FileReader();
      reader.onload = function() {
          observer.next(this.result);
          observer.complete();
      }
      reader.readAsText(blob);
  });
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.FileuploadApi.service.ts